import { Check, Sparkles } from 'lucide-react';

import { Avatar } from '@/design-system/ui/Avatar';
import { Badge } from '@/design-system/ui/Badge';

import SlideCopy, { FloatingNote } from './SlideCopy';

const ROWS = [
  { role: 'Portaria', people: ['Ana Costa', 'João Silva'] },
  { role: 'Guardiões', people: ['Rafael Mendes', 'Paula Ribeiro'] },
  { role: 'Projeção', people: ['Lucas Teixeira'] },
];

/** Destaque das escalas: um evento com a escala completa, montada pela geração automática. */
export default function ScheduleSlide() {
  return (
    <>
      <SlideCopy
        icon={Sparkles}
        tag="Geração automática de escalas"
        title="Pessoas certas, na função certa, em cada evento."
        text="Disponibilidade, funções e histórico de cada membro em um só lugar. A escala é montada respeitando as regras do ministério."
      />

      <div aria-hidden className="flex max-w-115 flex-col gap-3">
        <div className="overflow-hidden rounded-card bg-white text-ink shadow-dialog">
          <div className="flex items-center gap-3 border-b border-line-divider px-4 py-3.5">
            <span className="flex size-11 flex-col items-center justify-center rounded-control bg-accent-purple-soft leading-none text-accent-purple">
              <span className="text-micro font-bold uppercase">Dom</span>
              <span className="text-lead font-extrabold">12</span>
            </span>
            <div className="min-w-0 flex-1">
              <p className="m-0 text-body font-bold">Culto da Noite</p>
              <p className="m-0 text-meta text-ink-subtle">19:00 · Recepção, Multimídia</p>
            </div>
            <Badge tone="complete">
              <Check />
              Completa
            </Badge>
          </div>
          <div className="flex flex-col px-4 pt-1.5 pb-3.5">
            {ROWS.map((row) => (
              <div
                key={row.role}
                className="flex items-center gap-2.5 border-b border-surface-muted py-2.25 last:border-0"
              >
                <span className="size-1.5 rounded-pill bg-status-complete-bar" />
                <span className="w-24 text-small font-semibold">{row.role}</span>
                <span className="flex flex-wrap gap-1.5">
                  {row.people.map((name) => (
                    <span
                      key={name}
                      className="inline-flex h-6.5 items-center gap-1.5 rounded-pill bg-surface-muted pr-2.5 pl-0.75 text-caption font-medium"
                    >
                      <Avatar name={name} size="xs" />
                      {name.split(' ')[0]} {name.split(' ')[1]?.[0]}.
                    </span>
                  ))}
                </span>
              </div>
            ))}
          </div>
        </div>
        <FloatingNote>
          <span className="grid size-9 place-items-center rounded-control bg-primary-soft text-primary">
            <Sparkles className="size-4 stroke-2" />
          </span>
          <div>
            <p className="m-0 text-caption text-ink-subtle">Escala gerada em 3 s</p>
            <p className="m-0 text-body font-bold">100% das funções preenchidas</p>
          </div>
        </FloatingNote>
      </div>
    </>
  );
}
